import React from 'react';
import styled from 'styled-components';
import { em } from 'polished';
import { media } from 'core/layout';
import { colors, elevation } from 'core/theme';
import tulkojumi from 'utils/tulkojumi';
import uid from 'utils/uid';
import { Button } from 'elements';
import { ButtonStylerGrey } from 'elements/Button/styled';
import FontSizeIcon from './components/FontSizeIcon';


const levels = {
  small: {
    label: '75%',
    value: 0.75,
  },
  normal: {
    label: '100%',
    value: 1.0,
    selected: true,
  },
  medium: {
    label: '125%',
    value: 1.25,
  },
  large: {
    label: '150%',
    value: 1.5,
  },
};

const optionKeys = Object.keys(levels);


const Wrapper = styled.div`
  position: relative;
`;

const ListDrop = styled.ul`
  list-style: none;
  margin: 0;
  padding-left: 0;

  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  z-index: 100;

  background-color: ${colors.background};
  border-radius: 2px;
  box-shadow: ${elevation.Z2};
  display: ${props => props.open ? 'block' : 'none'};
  padding: ${em(16)};
`;

const MenuItem = styled.li`
  &[aria-selected="true"] {
    button {
      color: ${colors.secondary};
      pointer-events: none;
    }
  }
`;

const InlineLayout = styled.div`
  display: flex;
  margin-top: 2em;

  padding-left: 60px;
  ${media.tablet`
    padding-left: 32px;
  `};

  ${media.tabletSmall`
    padding-left: 20px;
  `};

  & > p {
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    width: 38px;
  }

  & > ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding-left: 1em;

    flex: 1 1 auto;
    flex-wrap: wrap;

    button {
      min-width: 62px;
    }
  }
`;


class FontSizeMenu extends React.PureComponent {
  state = {
    open: false,
    selectedOption: undefined,
  };

  componentDidMount() {
    if (window) {
      this._uid = uid();

      let selectedOptionId;
      optionKeys.find((key, i) => {
        const option = levels[key];
        if (option.selected) {
          selectedOptionId = `${this._uid}-${i + 1}`;
        }
        return option.selected;
      });

      if (selectedOptionId !== this.state.selectedOption) {
        this.setState(prevState => Object.assign({}, prevState, {
          selectedOption: selectedOptionId,
        }))
      }

      window.addEventListener('click', this._onWindowClick);
    }
  }

  _onMenuClick = (event) => {
    if (!this.state.open) {
      this.setState(prevState => Object.assign({}, prevState, {
        open: true,
      }), () => {
        // NOTE: Novietojam fokusu uz izvēlēto elementu uzreiz pēc menu atvēršanas
        const selectedOption = this._menu.querySelector('li[aria-selected="true"]');
        if (selectedOption) {
          const button = selectedOption.querySelector('button');
          button.focus();
        }
      });
    }
  }

  _onWindowClick = (event) => {
    if (event.target.id === this._uid) {
      event.stopImmediatePropagation();
      return;
    }
    if (this.state.open) {
      this.setState(prevState => Object.assign({}, prevState, {
        open: false,
      }));
    }
  }

  _onChanged = (globalId, item) => {
    if (this.state.selectedOption !== globalId) {
      this.setState(prevState => Object.assign({}, prevState, {
        selectedOption: globalId,
      }), () => {
        const { onChange } = this.props;
        onChange && onChange(item);
      });
    }
  }

  render() {
    const { teksti, inline = false } = this.props;

    const options = optionKeys.map((id, i) => {
      const item = levels[id];
      const globalId = `${this._uid}-${i + 1}`;
      return (
        <MenuItem
          key={globalId}
          id={globalId}
          role='option'
          aria-selected={this.state.selectedOption && this.state.selectedOption === globalId}
        >
          <ButtonStylerGrey>
            <Button
              tabIndex={this.state.open ? '0' : '-1'}
              type='text'
              label={item.label}
              // a11yLabel={`${tulkojumi(teksti, 'teksta_izmers')} – ${item.label}`}
              title={`${tulkojumi(teksti, 'teksta_izmers')} – ${item.label}`}
              onClick={() => {
                this._onChanged(globalId, item);
              }}
            />
          </ButtonStylerGrey>
        </MenuItem>
      );
    });

    if (inline) {
      return (
        <InlineLayout>
          <p title={tulkojumi(teksti, 'teksta_izmers')}>
            <FontSizeIcon />
          </p>
          <ul>
            {options}
          </ul>
        </InlineLayout>
      );
    }

    return (
      <Wrapper
        role='listbox'
        aria-activedescendant={this.state.selectedOption}
      >
        <ButtonStylerGrey>
          <Button
            type='text'
            id={this._uid}
            // a11yLabel={tulkojumi(teksti, 'teksta_izmers')}
            title={tulkojumi(teksti, 'teksta_izmers')}
            onClick={this._onMenuClick}
          >
            <FontSizeIcon />
          </Button>
        </ButtonStylerGrey>

        <ListDrop
          innerRef={c => this._menu = c}
          open={this.state.open}
        >
          { options }
        </ListDrop>
      </Wrapper>
    );
  }
}

export default FontSizeMenu;



// WEBPACK FOOTER //
// ./src/modules/Header/components/FontSizeMenu/FontSizeMenu.jsx